import { desktopBreakpoint } from 'react-components'
import styled, { css } from 'styled-components'
import ChevronDown from '../../../../assets/icons/chevron-down.svg'
import SortHamburger from '../../../../assets/icons/sort-hamburger.svg'

export const DesktopSortContainer = styled.div<{ isOpen?: boolean }>(
    ({ theme, isOpen }) => css`
        display: none;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            display: ${isOpen ? 'block' : 'none'};
            position: absolute;
            top: 100%;
            left: 0;
            padding: ${theme.spacing.xSmall};
            min-width: 23.125rem;
            margin-top: ${theme.spacing.xSmall};
            box-shadow:
                0 8px 10px #0000000f,
                0 3px 14px #0000000a,
                0 5px 5px #00000014;
            border-radius: ${theme.typography.border.radius.small};
            background-color: ${theme.colors.white};
            z-index: 1000;
        }
    `,
)

export const Container = styled.div`
    position: relative;
    max-width: 13rem;
`

export const StyledChevron = styled(ChevronDown)<{ $isOpen?: boolean }>(
    ({ $isOpen }) => css`
        transform: rotate(${$isOpen ? '180deg' : '0deg'});
        transition: transform 0.3s ease-in-out;
        width: 0.875rem;
    `,
)

export const SortIcon = styled(SortHamburger)`
    width: 1rem;
    height: 1rem;
`

export const ChipWrapper = styled.div(
    ({ theme }) => css`
        > div {
            height: 2.15rem;
            padding: 0.5rem ${theme.spacing.xSmall};
            display: flex;
            gap: ${theme.spacing.xxSmall};
            border-radius: 8rem;

            @media only screen and (min-width: ${desktopBreakpoint.min}px) {
                flex-direction: row-reverse;
            }
        }
    `,
)
